import React, { useState, useEffect } from "react";
import StudentDataService from "../../services/student/StudentService";
import SchoolDataService from '../../services/school/SchoolService';
import { validate } from "jest-validate";

const AddStudentPanel = ({props, savedCallback}) => {
  const initialStudentState = StudentDataService.initialiseNewStudent();
  const [currentStudent, setCurrentStudent] = useState(initialStudentState);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [saved, setSaved] = useState(false);
  const [schools, setSchools] = useState([]);
  
  useEffect(() => {
    SchoolDataService.getAll()
      .then((response) => {
        setSchools(response);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentStudent({ ...currentStudent, [name]: value });
  };

  const handleSchoolSelection = event => {
    const { value } = event.target;
    const selectedSchool = schools.find(s => s.id === value);
    setCurrentStudent({ ...currentStudent, school: selectedSchool });
  };

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    setCurrentStudent({ ...currentStudent, [name]: checked });
  };

  const validate = () => {
    const errorFields = [];
    if (currentStudent.school.id === 0) {
      errorFields.push('School');
    } 
    if (!currentStudent.firstName) {
      errorFields.push('First Name');
    }
    if (!currentStudent.lastName) {
      errorFields.push('Last Name');
    }

    if (errorFields.length) {
      setErrorMessage(`These fields may not be blank: ${errorFields.join(',')}`);
      return false;
    } else {
      setErrorMessage(null);
      return true;
    }
  };

  const addStudent = () => {
    if (validate()) {
      StudentDataService.create(currentStudent)
        .then(response => {
          console.log(response);
          setSaved(true);
          savedCallback();
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  const resetForm = () => {
      setCurrentStudent(StudentDataService.initialiseNewStudent());
      setSaved(false);
  }

  const showTermsAndConditions = () => {
    window.open('/terms.html', '_blank', 'noopener,noreferrer');
  }

  const renderBody = () => {
      if (saved) {
          return (
              <div>
                  <p>{currentStudent?.firstName} {currentStudent?.lastName} - Saved successfully!</p>
                  <p>One of the Cool Kids English team will contact you to complete registration.</p>
                  <p>
                      Please  <button
              type="submit"
              className="btn btn-outline-primary"
              onClick={resetForm}
          >
              Click Here
          </button> to add another
                    </p>
              </div>
          );
      };

      return (
        <div className="edit-form">
        <p>Please use this form to register your child with Cool Kids English.</p>
        <p>One of the Cool Kids English team will contact you to complete your registration.</p>
        <h4>Register New Student</h4>
        <form>
          <div className="form-group">
            <label htmlFor="title">First Name(*)</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              name="firstName"
              value={currentStudent.firstName}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="title">Last Name(*)</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              name="lastName"
              value={currentStudent.lastName}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="school">School(*)</label>
            <select
              className="form-select"
              id="school"
              name="school"
              value={currentStudent.school.id}
              onChange={handleSchoolSelection}>
              <option value="0" selected disabled hidden>- Select School -</option>
              {schools.map((school) => <option key={school.id} value={school.id}>{school.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="title">Year</label>
            <input
              type="text"
              className="form-control"
              id="year"
              name="year"
              value={currentStudent.year}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="title">Notes
            <div className="smallInfo">Please state any relevant information about your child here</div>
            </label>
            
            <textarea
            style={{height: 100}}
            type="text"
            className="form-control"
            id="parentNotes"
            name="parentNotes"
            value={currentStudent.parentNotes}
            onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <input
              className="form-check-input"
              type="checkbox"
              id="termsAccepted"
              name="termsAccepted"
              checked={currentStudent.termsAccepted}
              onClick={handleCheckboxChange}
            />
            <label htmlFor="termsAccepted" className="form-check-label">I have read and accept the <a href="#" onClick={showTermsAndConditions}>Terms and Conditions</a></label>
          </div>
        </form>
        <br></br>
        <div className="buttonRow">
          <button
              type="submit"
              disabled={!currentStudent.termsAccepted}
              className="btn btn-outline-primary"
              onClick={addStudent}
          >
              Register
          </button>
          <button
              className="btn btn-outline-secondary"
              onClick={resetForm}
            >
              Clear
            </button>
        </div>
        <p>{message}</p>
        <p className="errorText">{errorMessage}</p>
      </div>
      )
  }
  return (
    <div>
        {renderBody()}
    </div>
  );
};

export default AddStudentPanel;